webpackJsonp([49],{

/***/ "./node_modules/event-widgets/lib/CountdownTimer/CountdownTimerWidget.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BaseWidget2 = __webpack_require__("./node_modules/nucleus-widgets/lib/BaseWidget.js");

var _BaseWidget3 = _interopRequireDefault(_BaseWidget2);

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _CountdownTimerWidget = __webpack_require__("./node_modules/nucleus-widgets/lib/CountdownTimer/CountdownTimerWidget.js");

var _CountdownTimerWidget2 = _interopRequireDefault(_CountdownTimerWidget);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

/**
* A widget to display a countdown timer for either the event start date or the
* registration close date.
*/
var CountdownTimerWidget = function (_BaseWidget) {
  _inherits(CountdownTimerWidget, _BaseWidget);

  function CountdownTimerWidget() {
    _classCallCheck(this, CountdownTimerWidget);

    return _possibleConstructorReturn(this, _BaseWidget.apply(this, arguments));
  }

  CountdownTimerWidget.prototype.render = function render() {
    var _props = this.props,
        config = _props.config,
        closeDate = _props.closeDate,
        startDate = _props.startDate,
        other = _objectWithoutProperties(_props, ['config', 'closeDate', 'startDate']);

    var endDate = void 0;
    switch (config.dateSource) {
      case 'startDate':
        endDate = startDate;
        break;
      case 'closeDate':
        endDate = closeDate;
        break;
      default:
        endDate = new Date();
    }
    return _react2.default.createElement(_CountdownTimerWidget2.default, _extends({}, other, {
      config: _extends({}, config, { date: endDate }) }));
  };

  return CountdownTimerWidget;
}(_BaseWidget3.default);

CountdownTimerWidget.displayName = 'CountdownTimerWidget';
CountdownTimerWidget.propTypes = {
  config: _propTypes2.default.shape({}), // have different Component for flip and circle ???
  style: _propTypes2.default.object,
  translate: _propTypes2.default.func
};
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    startDate: state.event.startDate,
    closeDate: state.event.closeDate
  };
})(CountdownTimerWidget);

/***/ }),

/***/ "./node_modules/nucleus-core/counters/CircleCounter.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _nucleusDynamicCss = __webpack_require__("./node_modules/@cvent/nucleus-dynamic-css/lib/es/index.js");

var _nucleusTestAutomation = __webpack_require__("./node_modules/@cvent/nucleus-test-automation/lib/es/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
# CircleCounter Component
**/
var CircleCounter = function CircleCounter(props) {
  var label = props.label,
      digit = props.digit,
      type = props.type,
      total = props.total,
      fillingAnimationStartAt = props.fillingAnimationStartAt;

  var degree = void 0;
  if (fillingAnimationStartAt && fillingAnimationStartAt > total) {
    degree = 0;
  } else {
    var counterDigit = digit;
    while (counterDigit > total) {
      counterDigit = counterDigit - total; // Mostly used for days; prevent counter from looking wrong
    }
    degree = 360 - Math.floor(counterDigit / total * 360);
  }
  var rotation = 'rotate(' + degree + 'deg)';
  var halfRotation = 'rotate(' + degree / 2 + 'deg)';
  var spinnerStyle = {
    WebkitTransform: rotation,
    MozTransform: rotation,
    msTransform: rotation,
    Otransform: rotation,
    transform: rotation
  };
  var fillerStyle = {
    WebkitTransform: halfRotation,
    MozTransform: halfRotation,
    msTransform: halfRotation,
    Otransform: halfRotation,
    transform: halfRotation
  };

  var maskCss = (0, _nucleusDynamicCss.resolve)(props, 'mask');
  var fillerCss = (0, _nucleusDynamicCss.resolve)(props, 'border', type + 'Filler');
  var spinnerCss = (0, _nucleusDynamicCss.resolve)(props, 'border', type + 'Spinner');

  return _react2.default.createElement(
    'li',
    _extends({}, (0, _nucleusTestAutomation.resolveTestId)(props), (0, _nucleusDynamicCss.resolve)(props, 'counter')),
    _react2.default.createElement(
      'div',
      (0, _nucleusDynamicCss.resolve)(props, 'wrapper'),
      _react2.default.createElement(
        'div',
        (0, _nucleusDynamicCss.resolve)(props, 'circle'),
        _react2.default.createElement(
          'div',
          _extends({}, maskCss, { style: _extends({}, maskCss.style, fillerStyle) }),
          _react2.default.createElement('div', _extends({}, fillerCss, { style: _extends({}, fillerCss.style, fillerStyle) }))
        ),
        _react2.default.createElement(
          'div',
          maskCss,
          _react2.default.createElement('div', _extends({}, fillerCss, { style: _extends({}, fillerCss.style, fillerStyle) })),
          _react2.default.createElement('div', _extends({}, spinnerCss, { style: _extends({}, spinnerCss.style, spinnerStyle) }))
        ),
        _react2.default.createElement(
          'div',
          (0, _nucleusDynamicCss.resolve)(props, 'digit', type + 'Digit'),
          _react2.default.createElement(
            'span',
            null,
            digit
          )
        )
      )
    ),
    _react2.default.createElement(
      'span',
      (0, _nucleusDynamicCss.resolve)(props, 'label'),
      label
    )
  );
};

CircleCounter.displayName = 'CircleCounter';
CircleCounter.propTypes =  false ? {
  /** Label text for the counter. */
  label: _propTypes2.default.string,
  /** The actual value to display in the counter. */
  digit: _propTypes2.default.number.isRequired,
  /** The unit of measurement for the counter. */
  type: _propTypes2.default.oneOf(['days', 'hours', 'minutes', 'seconds']).isRequired,
  /** The max number of the unit of measurement. */
  total: _propTypes2.default.number.isRequired,
  /** optional; sets the value of when animation starts; if omitted, defaults to the total value */
  fillingAnimationStartAt: _propTypes2.default.number,
  /** Available Style Keys. */
  style: _propTypes2.default.shape({
    /** Mask styles */
    mask: _propTypes2.default.object,
    /** Top level style applied to the container. */
    counter: _propTypes2.default.object,
    /** Style applied to the wrapper around circle part of the counter. */
    wrapper: _propTypes2.default.object,
    /** Style applied to the circle part of the counter. */
    circle: _propTypes2.default.object,
    /** Style applied to the label part of the counter. */
    label: _propTypes2.default.object,
    /** Style for days filler. */
    daysFiller: _propTypes2.default.object,
    /** Style for hours filler. */
    hoursFiller: _propTypes2.default.object,
    /** Style for minutes filler. */
    minutesFiller: _propTypes2.default.object,
    /** Style for seconds filler. */
    secondsFiller: _propTypes2.default.object,
    /** Style for days spinner. */
    daysSpinner: _propTypes2.default.object,
    /** Style for hours spinner. */
    hoursSpinner: _propTypes2.default.object,
    /** Style for minutes spinner. */
    minutesSpinner: _propTypes2.default.object,
    /** Style for seconds spinner. */
    secondsSpinner: _propTypes2.default.object,
    /** Style for days digit. */
    daysDigit: _propTypes2.default.object,
    /** Style for housr digit. */
    hoursDigit: _propTypes2.default.object,
    /** Style for minutes digit. */
    minutesDigit: _propTypes2.default.object,
    /** Style for seconds digit. */
    secondsDigit: _propTypes2.default.object
  })
} : {};

exports.default = CircleCounter;

/***/ }),

/***/ "./node_modules/nucleus-core/counters/Countdown.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TextCounter = __webpack_require__("./node_modules/nucleus-core/counters/TextCounter.js");

var _TextCounter2 = _interopRequireDefault(_TextCounter);

var _CircleCounter = __webpack_require__("./node_modules/nucleus-core/counters/CircleCounter.js");

var _CircleCounter2 = _interopRequireDefault(_CircleCounter);

var _FlipCounter = __webpack_require__("./node_modules/nucleus-core/counters/FlipCounter.js");

var _FlipCounter2 = _interopRequireDefault(_FlipCounter);

var _nucleusDynamicCss = __webpack_require__("./node_modules/@cvent/nucleus-dynamic-css/lib/es/index.js");

var _nucleusTestAutomation = __webpack_require__("./node_modules/@cvent/nucleus-test-automation/lib/es/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

/**
# Countdown Component
**/
var Countdown = function (_React$Component) {
  _inherits(Countdown, _React$Component);

  function Countdown(props) {
    _classCallCheck(this, Countdown);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.getCoundownStateFromEndDate = _this.getCoundownStateFromEndDate.bind(_this);
    _this.clearCountdown = _this.clearCountdown.bind(_this);
    _this.startCountdown = _this.startCountdown.bind(_this);
    _this.state = _this.getCoundownStateFromEndDate(props.endDate);
    _this.countdownTimer = null;
    return _this;
  }

  Countdown.prototype.componentDidMount = function componentDidMount() {
    this.startCountdown();
  };

  Countdown.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.endDate.getTime() !== this.props.endDate.getTime()) {
      this.clearCountdown();
      this.setState(this.getCoundownStateFromEndDate(nextProps.endDate));
      this.startCountdown();
    }
  };

  Countdown.prototype.componentWillUnmount = function componentWillUnmount() {
    this.clearCountdown();
  };

  Countdown.prototype.getCoundownStateFromEndDate = function getCoundownStateFromEndDate(endDate) {
    if (endDate <= new Date()) {
      return {
        daysLeft: 0,
        hoursLeft: 0,
        minutesLeft: 0,
        secondsLeft: 0,
        millisecondsLeft: 0,
        inProgress: false
      };
    }
    var milliseconds = endDate.getTime() - new Date().getTime();
    var days = parseInt(milliseconds / 86400000, 10);
    milliseconds = milliseconds % 86400000;
    var hours = parseInt(milliseconds / 3600000, 10);
    milliseconds = milliseconds % 3600000;
    var minutes = parseInt(milliseconds / 60000, 10);
    milliseconds = milliseconds % 60000;
    var seconds = parseInt(milliseconds / 1000, 10);
    milliseconds = parseInt(milliseconds % 1000, 10);
    return {
      daysLeft: days,
      hoursLeft: hours,
      minutesLeft: minutes,
      secondsLeft: seconds,
      millisecondsLeft: milliseconds,
      inProgress: true
    };
  };

  Countdown.prototype.clearCountdown = function clearCountdown() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
      this.countdownTimer = null;
    }
  };

  Countdown.prototype.startCountdown = function startCountdown() {
    var _this2 = this;

    if (this.state.inProgress) {
      setTimeout(function () {
        _this2.setState(_this2.getCoundownStateFromEndDate(_this2.props.endDate));
        _this2.countdownTimer = setInterval(function () {
          if (_this2.state.inProgress) {
            _this2.setState(_this2.getCoundownStateFromEndDate(_this2.props.endDate));
          } else {
            clearInterval(_this2.countdownTimer);
            _this2.countdownTimer = null;
          }
        }, 1000);
      }, this.state.millisecondsLeft);
    }
  };

  Countdown.prototype.render = function render() {
    var CounterComponent = void 0;
    switch (this.props.type) {
      case 'circle':
        CounterComponent = _CircleCounter2.default;
        break;
      case 'flip':
        CounterComponent = _FlipCounter2.default;
        break;
      case 'text':
        CounterComponent = _TextCounter2.default;
        break;
      default:
        throw new Error('Provided countdown type is not supported: ' + this.props.type);
    }
    return _react2.default.createElement(
      'ul',
      _extends({}, (0, _nucleusTestAutomation.resolveTestId)(this.props), (0, _nucleusDynamicCss.resolve)(this.props, 'countdown')),
      this.props.showDays ? _react2.default.createElement(CounterComponent, _extends({}, (0, _nucleusDynamicCss.select)(this.props, this.props.type), {
        label: this.props.daysLabel,
        digit: this.state.daysLeft,
        total: 30,
        type: 'days'
      })) : null,
      this.props.showHours ? _react2.default.createElement(CounterComponent, _extends({}, (0, _nucleusDynamicCss.select)(this.props, this.props.type), {
        label: this.props.hoursLabel,
        digit: this.state.hoursLeft,
        total: 24,
        type: 'hours'
      })) : null,
      this.props.showMinutes ? _react2.default.createElement(CounterComponent, _extends({}, (0, _nucleusDynamicCss.select)(this.props, this.props.type), {
        label: this.props.minutesLabel,
        digit: this.state.minutesLeft,
        total: 60,
        type: 'minutes'
      })) : null,
      this.props.showSeconds ? _react2.default.createElement(CounterComponent, _extends({}, (0, _nucleusDynamicCss.select)(this.props, this.props.type), {
        label: this.props.secondsLabel,
        digit: this.state.secondsLeft,
        total: 60,
        type: 'seconds'
      })) : null
    );
  };

  return Countdown;
}(_react2.default.Component);

Countdown.displayName = 'Countdown';
Countdown.defaultProps = {
  showDays: true,
  showHours: true,
  showMinutes: true,
  showSeconds: true,
  type: 'circle'
};
exports.default = Countdown;
Countdown.propTypes =  false ? {
  /** When the countdown should end.  */
  endDate: _propTypes2.default.instanceOf(Date).isRequired,
  /** Flag indicating whether to show days value in the countdown. */
  showDays: _propTypes2.default.bool,
  /** Label for the days digit. */
  daysLabel: _propTypes2.default.string,
  /** Flag indicating whether to show hours value in the countdown. */
  showHours: _propTypes2.default.bool,
  /** Label for the hours digit. */
  hoursLabel: _propTypes2.default.string,
  /** Flag indicating whether to show minutes value in the countdown. */
  showMinutes: _propTypes2.default.bool,
  /** Label for the minutes digit. */
  minutesLabel: _propTypes2.default.string,
  /** Flag indicating whether to show seconds value in the countdown. */
  showSeconds: _propTypes2.default.bool,
  /** Label for the seconds digit. */
  secondsLabel: _propTypes2.default.string,
  /** The type of counter to display. */
  type: _propTypes2.default.oneOf(['circle', 'flip', 'text']),
  /** Available Style Keys. */
  style: _propTypes2.default.shape({
    /** Top level style applied to the ul element. */
    countdown: _propTypes2.default.object,
    /** Style applied to CircleCounter component. */
    circle: _propTypes2.default.object,
    /** Style applied to FlipCounter component. */
    flip: _propTypes2.default.object,
    /** Style applied to TextCounter component. */
    text: _propTypes2.default.object
  })
} : {};

/***/ }),

/***/ "./node_modules/nucleus-core/counters/FlipCounter.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _nucleusDynamicCss = __webpack_require__("./node_modules/@cvent/nucleus-dynamic-css/lib/es/index.js");

var _nucleusTestAutomation = __webpack_require__("./node_modules/@cvent/nucleus-test-automation/lib/es/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

/**
# FlipCounter Component
**/
var FlipCounter = function (_React$Component) {
  _inherits(FlipCounter, _React$Component);

  function FlipCounter(props) {
    _classCallCheck(this, FlipCounter);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.state = {
      flipping: false
    };
    return _this;
  }

  FlipCounter.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    setTimeout(function () {
      _this2.setState({
        flipping: true
      });
    });
  };

  FlipCounter.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this3 = this;

    /* eslint-disable react/no-did-update-set-state */
    // Need to verify if both not numbers becuase equality does not check this.
    if (isNaN(prevProps.digit) && isNaN(this.props.digit)) {
      return;
    }
    if (prevProps.digit === this.props.digit) {
      return;
    }
    this.setState({ flipping: false });
    setTimeout(function () {
      return _this3.setState({ flipping: true });
    }, 20);
  };

  FlipCounter.prototype.render = function render() {
    return _react2.default.createElement(
      'li',
      _extends({}, (0, _nucleusTestAutomation.resolveTestId)(this.props), (0, _nucleusDynamicCss.resolve)(this.props, 'counter')),
      _react2.default.createElement(
        'div',
        (0, _nucleusDynamicCss.resolve)(this.props, 'wrapper'),
        _react2.default.createElement(
          'div',
          (0, _nucleusDynamicCss.resolve)(this.props, 'digitWrapper'),
          _react2.default.createElement(
            'div',
            (0, _nucleusDynamicCss.resolve)(this.props, 'current', 'top', 'flip', this.state.flipping ? 'flipping' : ''),
            _react2.default.createElement(
              'div',
              (0, _nucleusDynamicCss.resolve)(this.props, 'digitTop'),
              _react2.default.createElement(
                'span',
                null,
                this.props.digit + 1 === 60 ? 0 : this.props.digit + 1
              )
            )
          ),
          _react2.default.createElement(
            'div',
            (0, _nucleusDynamicCss.resolve)(this.props, 'next', 'top', 'flip'),
            _react2.default.createElement(
              'div',
              (0, _nucleusDynamicCss.resolve)(this.props, 'digitTop'),
              _react2.default.createElement(
                'span',
                null,
                this.props.digit
              )
            )
          ),
          _react2.default.createElement(
            'div',
            (0, _nucleusDynamicCss.resolve)(this.props, 'current', 'bottom', 'flip'),
            _react2.default.createElement(
              'div',
              (0, _nucleusDynamicCss.resolve)(this.props, 'digit'),
              _react2.default.createElement(
                'span',
                null,
                this.props.digit + 1 === 60 ? 0 : this.props.digit + 1
              )
            )
          ),
          _react2.default.createElement(
            'div',
            (0, _nucleusDynamicCss.resolve)(this.props, 'next', 'bottom', 'flip', this.state.flipping ? 'flipping' : ''),
            _react2.default.createElement(
              'div',
              (0, _nucleusDynamicCss.resolve)(this.props, 'digit'),
              _react2.default.createElement(
                'span',
                null,
                this.props.digit
              )
            )
          )
        )
      ),
      _react2.default.createElement(
        'span',
        (0, _nucleusDynamicCss.resolve)(this.props, 'label'),
        this.props.label
      )
    );
  };

  return FlipCounter;
}(_react2.default.Component);

FlipCounter.displayName = 'FlipCounter';
exports.default = FlipCounter;
FlipCounter.propTypes =  false ? {
  /** Label text for the counter. */
  label: _propTypes2.default.string,
  /** The actual value to display in the counter. */
  digit: _propTypes2.default.number.isRequired,
  /** Available Style Keys. */
  style: _propTypes2.default.shape({
    /** Top level style applied to the container. */
    counter: _propTypes2.default.object,
    /** Style applied to the wrapper around the digit part of the counter. */
    wrapper: _propTypes2.default.object,
    /** Style applied to the digit part of the counter. */
    digitWrapper: _propTypes2.default.object,
    /** Style applied to the digit. */
    current: _propTypes2.default.object,
    /** Style applied to the digit. */
    top: _propTypes2.default.object,
    /** Style applied to the digit. */
    flip: _propTypes2.default.object,
    /** Style applied to the digit. */
    flipping: _propTypes2.default.object,
    /** Style applied to the digit. */
    digitTop: _propTypes2.default.object,
    /** Style applied to the digit. */
    next: _propTypes2.default.object,
    /** Style applied to the digit. */
    bottom: _propTypes2.default.object,
    /** Style applied to the digit. */
    digit: _propTypes2.default.object,
    /** Style applied to the label part of the counter. */
    label: _propTypes2.default.object
  })
} : {};

/***/ }),

/***/ "./node_modules/nucleus-core/counters/TextCounter.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _nucleusDynamicCss = __webpack_require__("./node_modules/@cvent/nucleus-dynamic-css/lib/es/index.js");

var _nucleusTestAutomation = __webpack_require__("./node_modules/@cvent/nucleus-test-automation/lib/es/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
# TextCounter Component
**/
var TextCounter = function TextCounter(props) {
  var label = props.label,
      digit = props.digit;

  return _react2.default.createElement(
    'span',
    _extends({}, (0, _nucleusTestAutomation.resolveTestId)(props), (0, _nucleusDynamicCss.resolve)(props, 'text')),
    _react2.default.createElement(
      'span',
      (0, _nucleusDynamicCss.resolve)(props, 'digit'),
      digit
    ),
    _react2.default.createElement(
      'span',
      (0, _nucleusDynamicCss.resolve)(props, 'label'),
      label
    )
  );
};

TextCounter.displayName = 'TextCounter';
TextCounter.propTypes =  false ? {
  /** Label text for the counter. */
  label: _propTypes2.default.string,
  /** The actual value to display in the counter. */
  digit: _propTypes2.default.number.isRequired,
  /** Available Style Keys. */
  style: _propTypes2.default.shape({
    /** Top level style applied to the container. */
    text: _propTypes2.default.object,
    /** Style applied to the digit part of the counter. */
    digit: _propTypes2.default.object,
    /** Style applied to the label part of the counter. */
    label: _propTypes2.default.object
  })
} : {};

exports.default = TextCounter;

/***/ }),

/***/ "./node_modules/nucleus-core/less/cv/Countdown.Circle.structure.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"Countdown-Circle-structure__container___2sIrU","countdown":"Countdown-Circle-structure__countdown___1m1JP","counter":"Countdown-Circle-structure__counter___2Ok4U","label":"Countdown-Circle-structure__label___1o8sQ","digit":"Countdown-Circle-structure__digit___LfVbi","daysDigit":"Countdown-Circle-structure__daysDigit___1I5Si Countdown-Circle-structure__digit___LfVbi","hoursDigit":"Countdown-Circle-structure__hoursDigit___1P1Ly Countdown-Circle-structure__digit___LfVbi","minutesDigit":"Countdown-Circle-structure__minutesDigit___nlMZf Countdown-Circle-structure__digit___LfVbi","secondsDigit":"Countdown-Circle-structure__secondsDigit___2X1x1 Countdown-Circle-structure__digit___LfVbi","circle":"Countdown-Circle-structure__circle___9MUZg","mask":"Countdown-Circle-structure__mask___SNG_M","border":"Countdown-Circle-structure__border___3PbHB","daysSpinner":"Countdown-Circle-structure__daysSpinner___oGNUg Countdown-Circle-structure__border___3PbHB","daysFiller":"Countdown-Circle-structure__daysFiller___3sWLq Countdown-Circle-structure__border___3PbHB","hoursSpinner":"Countdown-Circle-structure__hoursSpinner___3xFRZ Countdown-Circle-structure__border___3PbHB","hoursFiller":"Countdown-Circle-structure__hoursFiller___1Qf3U Countdown-Circle-structure__border___3PbHB","minutesSpinner":"Countdown-Circle-structure__minutesSpinner___2hQse Countdown-Circle-structure__border___3PbHB","minutesFiller":"Countdown-Circle-structure__minutesFiller___1DC0a Countdown-Circle-structure__border___3PbHB","secondsSpinner":"Countdown-Circle-structure__secondsSpinner___fTZ6k Countdown-Circle-structure__border___3PbHB","secondsFiller":"Countdown-Circle-structure__secondsFiller___2BuH2 Countdown-Circle-structure__border___3PbHB"};

/***/ }),

/***/ "./node_modules/nucleus-core/less/cv/Countdown.Flip.structure.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"Countdown-Flip-structure__container___13PMt","countdown":"Countdown-Flip-structure__countdown___X07cb","counter":"Countdown-Flip-structure__counter___27YrV","label":"Countdown-Flip-structure__label___EEUMj","wrapper":"Countdown-Flip-structure__wrapper___3POlU","digitTop":"Countdown-Flip-structure__digitTop___3gH2N","digit":"Countdown-Flip-structure__digit___1Mk6p","digitWrapper":"Countdown-Flip-structure__digitWrapper___1obBw","top":"Countdown-Flip-structure__top___1tNn2","current":"Countdown-Flip-structure__current___124Cb","next":"Countdown-Flip-structure__next___3wcl8","bottom":"Countdown-Flip-structure__bottom___2PtPD","flipping":"Countdown-Flip-structure__flipping___jjwck","flip":"Countdown-Flip-structure__flip___23nUN"};

/***/ }),

/***/ "./node_modules/nucleus-widgets/lib/CountdownTimer/CountdownTimer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _nucleusDynamicCss = __webpack_require__("./node_modules/@cvent/nucleus-dynamic-css/lib/es/index.js");

var _Countdown = __webpack_require__("./node_modules/nucleus-core/counters/Countdown.js");

var _Countdown2 = _interopRequireDefault(_Countdown);

var _nucleusTestAutomation = __webpack_require__("./node_modules/@cvent/nucleus-test-automation/lib/es/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* The CountdownTimer widget.
*/
var CountdownTimer = function CountdownTimer(props) {
  return _react2.default.createElement(
    'div',
    _extends({}, (0, _nucleusTestAutomation.resolveTestId)(props), (0, _nucleusDynamicCss.resolve)(props, 'container')),
    _react2.default.createElement(_Countdown2.default, props)
  );
};

CountdownTimer.displayName = 'CountdownTimer';
exports.default = CountdownTimer;

/***/ }),

/***/ "./node_modules/nucleus-widgets/lib/CountdownTimer/CountdownTimerWidget.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BaseWidget2 = __webpack_require__("./node_modules/nucleus-widgets/lib/BaseWidget.js");

var _BaseWidget3 = _interopRequireDefault(_BaseWidget2);

var _CountdownTimer = __webpack_require__("./node_modules/nucleus-widgets/lib/CountdownTimer/CountdownTimer.js");

var _CountdownTimer2 = _interopRequireDefault(_CountdownTimer);

var _CountdownCircleStructure = __webpack_require__("./node_modules/nucleus-core/less/cv/Countdown.Circle.structure.less");

var _CountdownCircleStructure2 = _interopRequireDefault(_CountdownCircleStructure);

var _CountdownFlipStructure = __webpack_require__("./node_modules/nucleus-core/less/cv/Countdown.Flip.structure.less");

var _CountdownFlipStructure2 = _interopRequireDefault(_CountdownFlipStructure);

var _nucleusTestAutomation = __webpack_require__("./node_modules/@cvent/nucleus-test-automation/lib/es/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var CountdownCircleStyle = {
  container: _CountdownCircleStructure2.default.container,
  countdown: _CountdownCircleStructure2.default.countdown,
  circle: _CountdownCircleStructure2.default
};
var CountdownFlipStyle = {
  container: _CountdownFlipStructure2.default.container,
  countdown: _CountdownFlipStructure2.default.countdown,
  flip: _CountdownFlipStructure2.default
};

/**
* Data wrapper for the CountdownTimer widget.
*/

var CountdownTimerWidget = function (_BaseWidget) {
  _inherits(CountdownTimerWidget, _BaseWidget);

  function CountdownTimerWidget() {
    _classCallCheck(this, CountdownTimerWidget);

    return _possibleConstructorReturn(this, _BaseWidget.apply(this, arguments));
  }

  CountdownTimerWidget.prototype.getStyleObject = function getStyleObject() {
    var counterBackground = this.getElementBackground('counter');
    if (this.props.config.type === 'flip') {
      counterBackground.borderRadius = 5;
    }
    return _extends({}, _BaseWidget.prototype.getStyleObject.call(this), {
      spacing: this.getElementSpacing('counter'),
      background: counterBackground,
      digit: this.getElementText('counter'),
      timer: this.getElementInlineStyle('counter'),
      label: this.getElementInlineStyle('text')
    });
  };

  CountdownTimerWidget.prototype.render = function render() {
    var _props = this.props,
        config = _props.config,
        translate = _props.translate;

    var inlineStyles = this.getStyleObject();
    var mergedStyles = {
      countdown: inlineStyles.container,
      circle: {
        counter: inlineStyles.spacing,
        circle: inlineStyles.background,
        digit: inlineStyles.digit,
        label: inlineStyles.label,
        border: inlineStyles.timer
      },
      flip: {
        counter: inlineStyles.spacing,
        top: inlineStyles.background,
        bottom: inlineStyles.background,
        flip: inlineStyles.background,
        digit: inlineStyles.digit,
        digitTop: inlineStyles.digit,
        label: inlineStyles.label
      }
    };
    var classes = config.type === 'circle' ? CountdownCircleStyle : CountdownFlipStyle;
    var endDate = new Date(config.date);
    return _react2.default.createElement(_CountdownTimer2.default, _extends({}, (0, _nucleusTestAutomation.resolveTestId)(this.props), {
      classes: classes,
      endDate: endDate,
      style: mergedStyles,
      type: config.type,
      daysLabel: translate('_dateLabels_days__resx'),
      showDays: config.showDays,
      hoursLabel: translate('_dateLabels_hours__resx'),
      showHours: config.showHours,
      minutesLabel: translate('_dateLabels_minutes__resx'),
      showMinutes: config.showMinutes,
      secondsLabel: translate('_dateLabels_seconds__resx'),
      showSeconds: config.showSeconds }));
  };

  return CountdownTimerWidget;
}(_BaseWidget3.default);

CountdownTimerWidget.displayName = 'CountdownTimerWidget';
CountdownTimerWidget.propTypes = {
  config: _propTypes2.default.shape({}), // have different Component for flip and circle ???
  style: _propTypes2.default.object,
  translate: _propTypes2.default.func
};
exports.default = CountdownTimerWidget;

/***/ })

});


// WEBPACK FOOTER //
// 49.prod._v4.420999c12664038f71d2.js